// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__s3brq","iconWithCounter":"styles_iconWithCounter__al9Q6","counterForLabel":"styles_counterForLabel___htXZ","counterForIcon":"styles_counterForIcon__OgAKN"};